(function(){
    'use strict'

    angular
    .module('app.feriados')
    .controller('Feriados', Feriados);

    Feriados.$inject = ['$animationsSrv', 'FeriadosService', 'logger', '$location', 'UserInfoService'];

    function Feriados($animationsSrv, FeriadosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.feriados = [];
        vm.title = 'Feriados';

        vm.goToEdit = function(feriado){
            
            var path = '/editar-feriado/';

            if(feriado){
                $location.path(path + feriado.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = FeriadosService.getAll();

            promise
            .then(function(feriados){
                vm.feriados = feriados;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los feriados.');
                        break;
                }
            });
        };

        vm.delete = function(feriado){
            var promise = FeriadosService.remove(feriado);
            
            promise
            .then(function(response){
                vm.feriados = vm.feriados.filter(function(g) {
                    return g.id !== feriado.id;
                });
                logger.success('Feriado eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Feriado');
                        break;
                }
                
            });   
        };

    }
})();